module.exports = __webpack_public_path__ + "assets/apple-touch-icon-152-prod-071b6b.png";